import React from "react";
import Images from "../../constants/Images";

import "./LandingPage.css";

export default function LandingPage() {
  return (
    <div className="landingPage-container">
      <div className="landingPage-subContainer">
        <div className="landingPage-eyebrow">AI Recipe Keeper</div>
        <div className="landingPage-mainText">
          Save Recipes From{`\n`}
          <span className="landingPage-highlight">Anywhere</span>
        </div>
        <div className="landingPage-subText">
          Import recipes from Instagram, TikTok and any website in seconds.
        </div>
        <div className="landingPage-downloadButtonsContainer">
          <a
            className="landingPage-downloadButton"
            href="https://apps.apple.com/us/app/inspo-ai-recipe-keeper/id6736347122"
          >
            <img
              src={Images.downloadButtonApple}
              alt="Download on the App Store"
              className="landingPage-downloadImage"
            />
          </a>
          <a
            className="landingPage-downloadButton"
            href="https://play.google.com/store/apps/details?id=com.kmoney.compile"
          >
            <img
              src={Images.downloadButtonGoogle}
              alt="Get it on Google Play"
              className="landingPage-downloadImage"
            />
          </a>
        </div>
      </div>
      <img
        src={Images.appScreenshots}
        className="landingPage-appScreenshotsImage"
        alt=""
      />
    </div>
  );
}
